// extracted by mini-css-extract-plugin
module.exports = {"form-message":"_3we2UOur"};